

export default function EnConstruction()
{
    return(
        <div className='Page'>
            <p>En Construction</p>
        </div>
    )
}